import { useState, useEffect } from "react";
import Modal from "../../../components/modal";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchProductAttributes,
  selectAllProductAttributes
} from "../../../slices/company/productAttributeSlice";
import CreatableDropdown from "./creatableDropdown";

const initialState = {
  product_type: "AB-OS",
  product_for: "M",
  product_name: "",
  product_serial: "",
  product_size: "",
  product_color: "",
  product_qty: "",
  product_price: "",
  product_tax: ""
};

// ✅ helper for comma-separated tags
const parseTags = (value) => {
  if (!value) return [];
  return value
    .split(",")
    .map(v => v.trim())
    .filter(Boolean);
};

const OtherScrapModal = ({ show, onClose, heading, cart = [], addCart }) => {
  const dispatch = useDispatch();
  const attributes = useSelector(selectAllProductAttributes);

  const [form, setForm] = useState(initialState);
  const [tempSizes, setTempSizes] = useState([]);
  const [tempColors, setTempColors] = useState([]);

  useEffect(() => {
    const company = JSON.parse(localStorage.getItem("company"));
    if (company) {
      dispatch(fetchProductAttributes(company.company?.id));
    }
  }, [dispatch]);

  // ✅ FIXED lowercase comparison
  const sizeAttribute = attributes?.find(
    attr => attr.name?.toLowerCase() === "size"
  );

  const colorAttribute = attributes?.find(
    attr => attr.name?.toLowerCase() === "color"
  );

  // ✅ Parse comma separated values
  const sizeOptions = [
    ...(sizeAttribute?.tags || []),
    ...tempSizes
  ];

  const colorOptions = [
    ...(colorAttribute?.tags || []),
    ...tempColors
  ];

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const resetForm = () => {
    setForm(initialState);
  };

  const handleAddToCart = () => {
    if (!form.product_name || !form.product_qty || !form.product_price) {
      alert("Product Name, Qty and Price are required");
      return;
    }

    addCart({
      product_data: {
        ...form,
        product_qty: Number(form.product_qty),
        product_price: Number(form.product_price),
        product_tax: Number(form.product_tax || 0),
      }
    });

    resetForm();
    onClose();
  };

  const handleSizeSelect = (val) => {
    if (!sizeOptions.includes(val)) {
      setTempSizes(prev => [...prev, val]);
    }
    setForm(prev => ({ ...prev, product_size: val }));
  };

  const handleColorSelect = (val) => {
    if (!colorOptions.includes(val)) {
      setTempColors(prev => [...prev, val]);
    }
    setForm(prev => ({ ...prev, product_color: val }));
  };


  return (
    <Modal show={show} onClose={onClose} heading={heading} size="lg">
      <div className="row">

        {/* Product Type */}
        <div className="col-md-4 mb-4">
          <label className="form-label">Product Type</label>
          <select
            name="product_type"
            value={form.product_type}
            onChange={handleChange}
            className="form-control"
          >
            <option value="AB-OS">AB OS</option>
            <option value="AB-SS">AB SS</option>
          </select>
        </div>
        <div className="col-md-4 mb-4">
          <label className="form-label">Product For</label>
          <select
            name="product_for"
            value={form.product_for}
            onChange={handleChange}
            className="form-control"
          >
            <option value="M">Men</option>
            <option value="W">Women</option>
            <option value="K">Kids</option>
          </select>
        </div>

        {/* Product Name */}
        <div className="col-md-4 mb-4">
          <label className="form-label">Product Name</label>
          <input
            type="text"
            name="product_name"
            value={form.product_name}
            onChange={handleChange}
            className="form-control"
          />
        </div>

        {/* Serial */}
        <div className="col-md-4 mb-4">
          <label className="form-label">Product Article No.</label>
          <input
            type="text"
            name="product_serial"
            value={form.product_serial}
            onChange={handleChange}
            className="form-control"
          />
        </div>

        {/* Size (comma separated) */}
        <div className="col-md-4 mb-4">
          <CreatableDropdown
            label="Product Size"
            value={form.product_size}
            options={sizeOptions}
            onChange={handleSizeSelect}
            placeholder="Type or select size"
          />
        </div>


        {/* Color (comma separated) */}
        <div className="col-md-4 mb-4">
          <CreatableDropdown
            label="Product Color"
            value={form.product_color}
            options={colorOptions}
            onChange={handleColorSelect}
            placeholder="Type or select color"
          />
        </div>


        {/* Qty */}
        <div className="col-md-4 mb-4">
          <label className="form-label">Product Qty</label>
          <input
            type="number"
            name="product_qty"
            value={form.product_qty}
            onChange={handleChange}
            className="form-control"
          />
        </div>

        {/* Price */}
        <div className="col-md-4 mb-4">
          <label className="form-label">Product Price</label>
          <input
            type="number"
            name="product_price"
            value={form.product_price}
            onChange={handleChange}
            className="form-control"
          />
        </div>

        {/* Tax */}
        <div className="col-md-4 mb-4">
          <label className="form-label">Product Tax (%)</label>
          <input
            type="number"
            name="product_tax"
            value={form.product_tax}
            onChange={handleChange}
            className="form-control"
          />
        </div>

        {/* Buttons */}
        <div className="col-md-12">
          <div className="d-flex justify-content-end">
            <button
              type="button"
              onClick={resetForm}
              className="btn btn-danger me-3"
            >
              Reset
            </button>
            <button
              type="button"
              onClick={handleAddToCart}
              className="btn btn-success"
            >
              Add To Cart
            </button>
          </div>
        </div>

      </div>
    </Modal>
  );
};

export default OtherScrapModal;
